// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yjKv","label":"styles_label__3JIyI"};